import {Extension} from '@tiptap/core'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    textDirection: {
      setTextDirection: (dir: 'rtl' | 'ltr' | null) => ReturnType
    }
  }
}

const DIRECTION_TYPES = ['paragraph', 'heading', 'blockquote', 'bulletList', 'orderedList']

/**
 * Per-block text direction stored as a plain `dir` attribute — matches the
 * RTL/LTR buttons of the legacy PHP Summernote plugin and renders correctly
 * in any consumer without CSS.
 */
export const TextDirection = Extension.create({
  name: 'textDirection',

  addGlobalAttributes() {
    return [
      {
        types: DIRECTION_TYPES,
        attributes: {
          dir: {
            default: null,
            parseHTML: (element) => {
              const dir = element.getAttribute('dir') || element.style.direction
              return dir === 'rtl' || dir === 'ltr' ? dir : null
            },
            renderHTML: (attributes) => {
              if (!attributes.dir) return {}
              return {dir: attributes.dir}
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      setTextDirection:
        (dir) =>
        ({editor, chain}) => {
          const chained = chain()
          let applied = false
          DIRECTION_TYPES.forEach((type) => {
            if (editor.isActive(type)) {
              chained.updateAttributes(type, {dir})
              applied = true
            }
          })
          return applied ? chained.run() : false
        },
    }
  },
})
